/**
 * Formats the "Showing X of Y" cell in the canonical AggregateStrip on v2 list
 * pages (ADV-787). When the dataset spans more than one page, render the
 * absolute row range (e.g. "51–100 of 1,200") rather than the page-window
 * length (which silently understates progress).
 *
 * - `total` undefined → render "—" (consistent with other aggregate cells).
 * - `total === 0` → "0 of 0".
 * - Single-page result → "<pageCount> of <total>".
 * - Multi-page result → "<start>–<end> of <total>".
 */
export function formatShowingRange(
  pageCount: number,
  pageIndex: number,
  pageSize: number,
  total: number | undefined,
): string {
  if (total == null) return "—";
  if (total === 0 || pageCount === 0) return `0 of ${total.toLocaleString()}`;
  const start = pageIndex * pageSize + 1;
  const end = Math.min(pageIndex * pageSize + pageCount, total);
  const totalLabel = total.toLocaleString();
  if (total <= pageSize) return `${pageCount} of ${totalLabel}`;
  return `${start}–${end} of ${totalLabel}`;
}
